import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import TherapyHome from "./TherapyHome";
import TherapyTherapists from "./TherapyTherapists";
import TherapyTherapistProfile from "./TherapyTherapistProfile";
import TherapyServices from "./TherapyServices";
import TherapyFAQ from "./TherapyFAQ";
import TherapyPolicies from "./TherapyPolicies";
import TherapyBooking from "./TherapyBooking";
import TherapyPractice from "./TherapyPractice";
import { path } from "./therapyPaths";

/**
 * TherapyApp — entry point for the Harbor Therapy demo.
 *
 * Mount with a wildcard so it owns every path under its base:
 *   <Route path="/portfolio/business-demo/*" element={<TherapyApp />} />
 *
 * All internal links use absolute paths via therapyPaths.js so they
 * work correctly regardless of which sub-page they're rendered on.
 *
 * Routes:
 *   /                          — TherapyHome (landing page)
 *   /therapists                — TherapyTherapists (filterable list)
 *   /therapists/:slug          — TherapyTherapistProfile (individual)
 *   /services                  — TherapyServices
 *   /practice                  — TherapyPractice (gallery + info)
 *   /faq                       — TherapyFAQ
 *   /policies                  — TherapyPolicies
 *   /booking                   — TherapyBooking (generic, free consult)
 *   /book/:slug                — TherapyBooking (with specific therapist)
 */

function TherapyApp() {
    return (
        <Routes>
            <Route index element={<TherapyHome />} />
            <Route path="therapists" element={<TherapyTherapists />} />
            <Route path="therapists/:slug" element={<TherapyTherapistProfile />} />
            <Route path="services" element={<TherapyServices />} />
            <Route path="practice" element={<TherapyPractice />} />
            <Route path="faq" element={<TherapyFAQ />} />
            <Route path="policies" element={<TherapyPolicies />} />
            <Route path="booking" element={<TherapyBooking />} />
            <Route path="book/:slug" element={<TherapyBooking />} />
            <Route path="*" element={<Navigate to={path()} replace />} />
        </Routes>
    );
}

export default TherapyApp;